import { render, staticRenderFns } from "./Crime.vue?vue&type=template&id=16705b46&"
import script from "./Crime.vue?vue&type=script&lang=js&"
export * from "./Crime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports